import React from "react";
import "./DeliveryPriceModal.css";
import InputField, { IInputField } from "../../inputField/InputField";
import Button from "../../button/Button";
import { AiFillCloseCircle } from "react-icons/ai";

type Props = {
  onClose?: () => void;
  title?: string;
  subTitle?: string;
  btnLabel?: string;
  inputPlaceHolder?: string;
  onActionBtnClick?: (arg?: any) => void;
  onChange?: (arg?: any) => void;
  inputProps?: Partial<IInputField>
};

function DeliveryPriceModal(props: Props) {
  const {
    onClose,
    subTitle,
    title,
    btnLabel,
    onActionBtnClick,
    inputPlaceHolder,
    onChange,
    inputProps
  } = props;

  const [price, setPrice] = React.useState("");
  return (
    <div className="delivery-price-modal-overlay" onClick={(e) => {
      if (e.target === e.currentTarget) {
        onClose && onClose();
    }
    }} >
      <div className="delivery-price-modal-container">
        <div className="delivery-price-modal-header">
          <div className="delivery-price-modal-header-title">
            {title || "Set Gas Delivery"}
          </div>
          <div className="delivery-price-modal-header-subtitle">
            {subTitle}
          </div>
        </div>

        <InputField
          {...inputProps}
          inputStyle={{ height: "40px", fontSize: "0.8rem" }}
          onChange={({ target: { value } }) => {setPrice(value); onChange && onChange(value)}}
          label=""
          name="gasPrice"
          value={price}
          placeholder={
            inputPlaceHolder || "Type incentive amount here (in percentage)"
          }
        />
        <Button
          style={{ width: "70%" }}
          onClick={() => onActionBtnClick && onActionBtnClick(price)}
          label={btnLabel || "Save changes"}
        />

        <AiFillCloseCircle
          className="delivery-price-modal-close-icon"
          onClick={() => {
            onClose && onClose();
          }}
        />
      </div>
    </div>
  );
}

export default DeliveryPriceModal;
